(function () {
    'use strict';

    window.cgcToggle = function () {
        var p = document.getElementById('cgcPanel');
        if (p.classList.contains('cgc-panel--open')) cgcClose();
        else cgcOpen();
    };

    window.cgcOpen = function () {
        document.getElementById('cgcPanel').classList.add('cgc-panel--open');
    };

    window.cgcClose = function () {
        document.getElementById('cgcPanel').classList.remove('cgc-panel--open');
        cgcShowView('home');
    };

    window.cgcShowView = function (view) {
        var views = ['cgcViewHome', 'cgcViewEarn', 'cgcViewRedeem', 'cgcSublunaSister', 'cgcMatchaMaiden', 'cgcSovereignSiren', 'cgcIslandHeiress'];
        views.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.style.display = 'none';
        });

        var target = 'cgcViewHome';
        if (view === 'earn') target = 'cgcViewEarn';
        else if (view === 'redeem') target = 'cgcViewRedeem';
        else if (view === 'sublunaSister') target = 'cgcSublunaSister';
        else if (view === 'matchaMaiden') target = 'cgcMatchaMaiden';
        else if (view === 'sovereignSiren') target = 'cgcSovereignSiren';
        else if (view === 'islandHeiress') target = 'cgcIslandHeiress';

        var el = document.getElementById(target);
        if (el) el.style.display = 'block';

        var backBtn = document.getElementById('cgcBackHome');
        if (backBtn) backBtn.classList.toggle('cgc-hero__back--visible', view !== 'home');

        document.getElementById('cgcBody').scrollTop = 0;
    };

    function loadPoints() {
        if (typeof Smile === 'undefined') return false;
        var c = Smile.legacySmile && Smile.legacySmile.customer;
        var el = document.getElementById('lunaCoins');
        if (el && c && c.points_balance !== undefined) {
        el.textContent = Smile.legacySmile.formatPoints(c.points_balance);
        return true;
        }
        return false;
    }

    function loadNextReward() {
        if (typeof Smile === 'undefined' || !Smile.legacySmile) return false;
        var balance = Smile.legacySmile.customer ? Smile.legacySmile.customer.points_balance : 0;

        Smile.legacySmile.fetchAllPointsProducts().then(function(products) {
        var sorted = products.sort(function(a, b) {
            return a.minimum_points_price - b.minimum_points_price;
        });

        var next = sorted.find(function(p) {
            return p.minimum_points_price > balance;
        }) || sorted[0];

        var row = document.getElementById('cgcNextRewardRow');
        if (!row || !next || !next.reward) return;

        var imgSrc = next.reward.image_url || '';
        row.innerHTML = '<span class="cgc-row__icon"><img alt="" role="presentation" src="' + imgSrc + '" class="list-item-image"></span>'
            + '<div class="cgc-row__info">'
            + '<div class="cgc-row__label">' + next.reward.name + '</div>'
            + '<div class="cgc-row__value cgc-text__muted">Earn ' + next.minimum_points_price.toLocaleString() + ' Luna Coins</div>'
            + '</div>';
        }).catch(function() {
        var row = document.getElementById('cgcNextRewardRow');
        if (row) row.innerHTML = '';
        });

        return true;
    }

    function loadReferral() {
        if (typeof Smile === 'undefined' || !Smile.legacySmile || !Smile.legacySmile.customer) return false;
        var customer = Smile.legacySmile.customer;
        var refUrl = customer.referral_url;
        var el = document.getElementById('cgcRefUrl');
        if (el && refUrl) {
        var customerId = customer.id;

        function buildRef(medium) {
            return btoa(JSON.stringify({
            smile_source: 'smile_ui',
            smile_medium: medium,
            smile_campaign: 'referral_program',
            smile_customer_id: customerId
            }));
        }

        var fullUrl = refUrl + '?smile_ref=' + buildRef('');
        el.value = fullUrl;

        var fb = document.getElementById('cgcShareFb');
        var tw = document.getElementById('cgcShareTw');
        var em = document.getElementById('cgcShareEm');
        if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + refUrl + '?smile_ref=' + buildRef('facebook');
        if (tw) tw.href = 'https://twitter.com/intent/tweet?url=' + refUrl + '?smile_ref=' + buildRef('twitter');
        if (em) em.href = 'mailto:?body=' + encodeURIComponent(refUrl + '?smile_ref=' + buildRef('email'));
        var sharing = document.getElementById('cgcRefSharing');
        if (sharing) sharing.style.display = 'flex';
        return true;
        }
        return false;
    }

    window.cgcCopyRef = function() {
        var input = document.getElementById('cgcRefUrl');
        var btn = document.getElementById('cgcRefCopy');
        if (!input || !input.value) return;
        navigator.clipboard.writeText(input.value).then(function() {
        btn.classList.add('cgc-ref-code__copy--copied');
        setTimeout(function() { btn.classList.remove('cgc-ref-code__copy--copied'); }, 2000);
        });
    };

    function loadReferralCount() {
        if (typeof Smile === 'undefined' || !Smile.legacySmile) return;
        Smile.legacySmile.fetchAllReferrals().then(function(refs) {
        var el = document.getElementById('cgcRefCount');
        if (el) el.textContent = refs.length;
        }).catch(function() {
        var el = document.getElementById('cgcRefCount');
        if (el) el.textContent = '0';
        });
    }

    if (!loadPoints()) {
        var _poll = setInterval(function() {
        if (loadPoints()) {
            clearInterval(_poll);
            loadNextReward();
            loadReferral();
            loadReferralCount();

        }
        }, 800);
        setTimeout(function() { clearInterval(_poll); }, 12000);
    } else {
        loadNextReward();
        loadReferral();
        loadReferralCount();

    }
})();
